import { SingleTeaser, TripleTeaser } from '@bnnvara/teasers';
import PropTypes from 'prop-types';
import React from 'react';
import { withTheme } from 'styled-components';

// uncomment for red color @portal
// import useBrand from '../../hooks/useBrand';
import {
  convertSingleTeaserItem,
  convertTripleTeaserItems,
} from '../../helpers/convertTeaser';

const BaseTeaser = ({ ...props }) => {
  const backgroundColor = ({ theme }) => theme.tertiary.main;

  // const brand = useBrand();
  // uncomment for red color @ portal
  // const backgroundColor =
  // brand.slug === 'portal'
  //   ? ({ theme }) => theme.base.red
  //   : ({ theme }) => theme.tertiary.light;

  const { items, LinkComponent, video } = props;

  if (!Array.isArray(items)) {
    return null;
  }

  if (items.length === 1) {
    return (
      <SingleTeaser
        {...convertSingleTeaserItem(items[0])}
        video={video}
        LinkComponent={LinkComponent}
        backgroundColor={backgroundColor}
      />
    );
  }

  if (items.length >= 2) {
    return (
      <TripleTeaser
        items={convertTripleTeaserItems(items)}
        LinkComponent={LinkComponent}
        backgroundColor={backgroundColor}
      />
    );
  }

  return null;
};

BaseTeaser.defaultProps = {
  LinkComponent: (props) => React.createElement('a', props),
  video: null,
};

BaseTeaser.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  video: PropTypes.node,
  LinkComponent: PropTypes.func,
};

export default withTheme(BaseTeaser);
